import React from "react";

import { graphql } from 'gatsby';
import { ThemeProvider } from 'styled-components'
import styled from "styled-components";
import { makeStyles } from "@material-ui/core/styles";

import Container from "@material-ui/core/Container";
import Typography from "@material-ui/core/Typography";
import Box from "@material-ui/core/Box";
import Paper from "@material-ui/core/Paper";
import Grid from "@material-ui/core/Grid";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemAvatar from "@material-ui/core/ListItemAvatar";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemSecondaryAction from "@material-ui/core/ListItemSecondaryAction";
import ListItemText from "@material-ui/core/ListItemText";
import Button from '@material-ui/core/Button';
import Hidden from '@material-ui/core/Hidden';
import Drawer from '@material-ui/core/Drawer';
import AppBar from '@material-ui/core/AppBar';
import { MenuItem } from '@material-ui/core';


import Link from "../components/Link";
import Layout from "../components/Layout";
import Seo from "../components/Seo";
import RightContainer from "../components/RightContainer";
import MUIDrawer from "../components/Drawer";

import theme from "../theme.js";

export const PostListItem = styled(ListItem)`
  font-family: Old Standard TT, serif;
  font-weight: bold;
 
`;

export const PostListItemText = styled(ListItemText)`

  font-family: Old Standard TT, serif;
  font-size: 2rem;
  font-weight: bold;

  ${props => props.theme.breakpoints.down("xs")} {
    font-size: 1.5em;
    font-weight: bold;
  }

`;

export const StyledPostLink = styled(Link)`
  font-family: Old Standard TT, serif;
  font-weight: bold;
  color: #AD5843;
  text-decoration: none;
  
  &:hover {
    text-decoration: underline;
  }
`;


export const StyledBox = styled(Box)`
  height: 100;
  display: flex;
  padding: 8;
  justify-content: space-between;
  align-items: center;
  margin-top: 3rem;
  margin-bottom: 2rem;
  width: 100%;
  max-width: inherit;
`;

export const StyledPrevNextLink = styled(Link)`
  font-family: Old Standard TT, serif;
  font-size: 1.2rem;
  font-weight: bold;
  color: #AD5843;
  text-decoration: none;
  
  &:hover {
    text-decoration: underline;
  }
`;

export const PostDate = styled.div`
  color: #AD5843;
  font-size: 0.85rem;
  font-family: Open Sans, sans-serif;
  font-weight: 500;
  font-variant: small-caps;
  letter-spacing: 0.5px;
  text-transform: uppercase;
  margin-bottom: 0.75rem;
  margin-top: 0;
`;


export const PostTitle = styled.h1`
  font-family: Old Standard TT, serif;
  font-size: 2.2rem;
  color: #4c494f;
  margin-top: 0;
  margin-bottom: 1.2rem;
  line-height: 1.35;
  letter-spacing: -0.02em;
  text-wrap: balance;
  font-feature-settings: "liga", "kern";
  
  /* Better handling of long titles */
  word-break: break-word;
  overflow-wrap: break-word;
  
  ${props => props.theme.breakpoints.down("xs")} {
    font-size: 2.1rem;
    letter-spacing: -0.01em;
    line-height: 1.3;
  }
`;

export const PostContent = styled.div`
  font-size: 1.1rem;
  font-family: Lora, serif;
  color: #333;
  line-height: 1.75;
  margin-top: 0;
  font-feature-settings: "liga", "kern";
  
  p {
    margin-bottom: 1.5rem;
  }
  
  h1, h2, h3, h4, h5, h6 {
    font-family: Old Standard TT, serif;
    margin-top: 2.5rem;
    margin-bottom: 1.2rem;
    color: #4c494f;
    line-height: 1.3;
    font-feature-settings: "liga", "kern";
  }
  
  blockquote {
    background: #FAF9F7;
    border-left: 4px solid #AD5843;
    margin: 2rem 0;
    padding: 1.2rem 1.5rem;
    font-style: italic;
    font-size: 1.05em;
    color: #555;
    border-radius: 0 4px 4px 0;
    
    p:last-child {
      margin-bottom: 0;
    }
  }
  
  code {
    background-color: #f8f8f8;
    padding: 0.2rem 0.5rem;
    border-radius: 4px;
    font-size: 0.9rem;
    color: #AD5843;
    font-family: "SF Mono", Monaco, "Cascadia Code", "Roboto Mono", Consolas, "Courier New", monospace;
  }
  
  pre {
    background-color: #f8f8f8;
    padding: 1.2rem;
    border-radius: 6px;
    overflow-x: auto;
    margin: 2rem 0;
    border: 1px solid #e8e8e8;
  }
  
  a {
    color: #AD5843;
    text-decoration: underline;
    text-decoration-thickness: 1px;
    text-underline-offset: 0.15em;
    transition: color 0.2s ease;
    
    &:hover {
      color: #9C4235;
      text-decoration: underline;
    }
  }
  
  img {
    max-width: 100%;
    height: auto;
    border-radius: 8px;
    box-shadow: 0 4px 12px rgba(0,0,0,0.1);
    margin: 2rem auto;
    display: block;
    
    ${props => props.theme.breakpoints.down("xs")} {
      margin: 1.5rem auto;
      border-radius: 6px;
    }
  }
`;

export const MenuContext = React.createContext({
  isOpen: false,
  setIsOpen: () => {}
});
